import { createFileRoute } from "@tanstack/react-router";
import { Prose } from "@/components/site/PageHeader";
import { EditablePageShell } from "@/components/site/EditablePageShell";
import { pageQueryOptions } from "@/lib/pages.functions";
import { SHARE_IMAGES } from "@/lib/share-images";
import { BUSINESS, ADDRESS_LINES } from "@/lib/business-info";

export const Route = createFileRoute("/shipping-returns")({
  loader: ({ context }) => context.queryClient.ensureQueryData(pageQueryOptions("shipping-returns")),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.title || "Shipping & Returns — Glow Long Golf" },
      { name: "description", content: loaderData?.meta_description || "How shipping and returns work for Glow Long Golf orders — delivery times, free shipping thresholds, and our 30-day return policy." },
      { property: "og:title", content: loaderData?.title || "Shipping & Returns — Glow Long Golf" },
      { property: "og:description", content: loaderData?.meta_description || "Delivery times, free shipping thresholds, and our 30-day return policy for Glow Long Golf orders." },
      { property: "og:url", content: "https://glowlonggolf.com/shipping-returns" },
      { property: "og:image", content: SHARE_IMAGES.macroDew },
      { name: "twitter:image", content: SHARE_IMAGES.macroDew },
    ],
    links: [{ rel: "canonical", href: "https://glowlonggolf.com/shipping-returns" }],
  }),

  errorComponent: ({ error }) => <div className="p-8 text-sm text-destructive" role="alert">{error.message}</div>,
  notFoundComponent: () => <div className="p-8 text-sm text-muted-foreground">Not found.</div>,
  component: () => (
    <EditablePageShell slug="shipping-returns" defaults={{ eyebrow: "Policies", title: "Shipping & returns" }}>
      <Prose>
        <h2>Shipping</h2>
        <p>Orders ship from Amazon's fulfillment network. Standard delivery is typically 2–5 business days in the contiguous US.</p>
        <p>Free shipping on orders over $50. Below that, shipping is calculated at checkout based on destination.</p>
        <h2>Returns</h2>
        <p>Unused, unopened packs may be returned within 30 days of delivery for a full refund (less original shipping). To start a return, email us at <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a> or call <a href={`tel:${BUSINESS.phoneHref}`}>{BUSINESS.phone}</a> with your order number.</p>
        <h2>Damaged or wrong items</h2>
        <p>If your order arrives damaged or incorrect, email us within 7 days of delivery with a photo and we'll make it right.</p>
        <h2>Return address</h2>
        <p>
          {BUSINESS.name}<br />
          {ADDRESS_LINES.map((line) => (
            <span key={line}>{line}<br /></span>
          ))}
        </p>
      </Prose>
    </EditablePageShell>
  ),
});
